import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useAxios } from '../../../AxiosHandler';
import Field from "../../Shared/Wizard/Field/Field";
import { useTranslate } from 'react-polyglot';
import { useHistory } from "react-router-dom";
import './LostPasword.scss';

function ResetPassword(){
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const t = useTranslate();
    const history = useHistory();
    
    
    let param = useParams();
    
    const [enteredPassword, setEnteredPassword] = useState("");
    const [retypePassword, setRetypePassword] = useState("");
    const [passwordsSame, setPasswordsSame] = useState(false);
    const [requestSendt, setRequestSendt] = useState(false);
    
    function sendReset(){
        axios.all([
            axios.single({
                method: "post",
                url: "/api/users/reset-password/" + param.token,
                responseType: "json",
                data: {password: enteredPassword}
            })
        ])
        .then(axios.spread((...res) => {
            
        }))
        .catch(err => console.log(err));
    }
    
    function handleResetPasswordButton(){
        if(passwordsSame){
            sendReset();
            setRequestSendt(true);
        }
    }
    
    function onChangePass(value){
        setEnteredPassword(value);
        setPasswordsSame(retypePassword == value && value != "");
    }
    
    function onChangeRetype(value){
        setRetypePassword(value);
        setPasswordsSame(enteredPassword == value && value != "");
    }
    
    function toLogin(evt){
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        history.push("/");
        
    }
    
    return (
        <div className="logincontainer">
            <div className="row justify-content-center">
                <div className="col-lg-5">
                    <Card>
                        <div className="card-header pt-4 pb-4 text-center login-header">
                            <a href="/">
                                <span><img src={"https://via.placeholder.com/120x120"} alt="" width="200" /></span>
                            </a>
                        </div>
                        <Card.Body>
                            <div className="welcometext">
                                <h4>{t("password.reset.title")}</h4>
                                <p>{t("password.reset.description")}</p>
                            </div>
                            <div className="loginform">
                                <div>
                                    <Field type="input" title={t("password.reset.password")} value={enteredPassword} onChange={onChangePass}/>
                                </div>
                                <div>
                                    <Field type="input" title={t("password.reset.retype")} value={retypePassword} onChange={onChangeRetype}/>
                                </div>
                                
                                <div className="buttonbox">
                                    <Button onClick={handleResetPasswordButton} disabled={!passwordsSame || requestSendt}>{t("password.reset.confirm")}</Button>
                                </div>
                                
                                {requestSendt ?
                                    <div className="confirmText">
                                        {t("password.reset.reset_confirmed")} 
                                    </div>
                                : ""}
                                
                                <div className="buttonbox">
                                    <Button onClick={toLogin}> {t("password.reset.back")} </Button>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
    
}


export default ResetPassword;